import { FC } from 'react';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import { Column } from 'further-ui/components/Layout';

const Container = styled(Column, {
  shouldForwardProp: (prop) => prop !== 'bordered',
})<{ bordered?: boolean }>(({ theme, bordered }) => ({
  padding: theme.spacing(theme.spacingSizes.xl),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
  ...(bordered && {
    border: `1px solid ${theme.palette.grey[300]}`,
  }),
}));

type Props = {
  size?: number;
  text?: string;
  bordered?: boolean;
  className?: string;
};

const Loader: FC<Props> = ({
  size = 32,
  text,
  bordered = false,
  className,
}) => {
  return (
    <Container
      spacing="sm"
      bordered={bordered}
      className={className}
      fullHeight
    >
      <CircularProgress size={size} />
      {text ? <Typography variant="body2">{text}</Typography> : null}
    </Container>
  );
};

export default Loader;
